import { combineReducers } from '@reduxjs/toolkit';
import { reducer as appReducer } from 'src/slices/app';
import { reducer as authReducer } from 'src/slices/auth';
import { reducer as deliveryReportReducer } from 'src/slices/deliveryReport';
import { reducer as passportsUploadReducer } from 'src/slices/passportsUpload';
import { reducer as currentPassportReducer } from 'src/slices/currentPassport';
import { reducer as passportsFilterReducer } from 'src/slices/passportsFilter';
import { reducer as archiveFilterReducer } from 'src/slices/archiveFilter';
import { reducer as repositoryReducer } from 'src/slices/repository';
import { reducer as RAOReportLogFilterReducer } from 'src/slices/RAOReportLogFilter';
import { reducer as archiveReducer } from 'src/slices/archive';

const rootReducer = combineReducers({
  app: appReducer,
  auth: authReducer,
  deliveryReport: deliveryReportReducer,
  passportsUpload: passportsUploadReducer,
  currentPassport: currentPassportReducer,
  passportFilters: passportsFilterReducer,
  archiveFilters: archiveFilterReducer,
  repository: repositoryReducer,
  raoLogFilter: RAOReportLogFilterReducer,
  archive: archiveReducer
});

export default rootReducer;
